(function () {

  let ORIGINAL_ANNOUNCEMENT_HTML = null;

  function captureOriginal() {
    const bar = document.querySelector("announcement-bar");
    if (!bar) return;

    // Capture only once when valid content exists
    if (
      !ORIGINAL_ANNOUNCEMENT_HTML &&
      bar.children.length > 0
    ) {
      ORIGINAL_ANNOUNCEMENT_HTML = bar.innerHTML;
    }
  }

  function restoreBar() {
    const bar = document.querySelector("announcement-bar");
    if (!bar) return;

    if (
      bar.children.length === 0 &&
      ORIGINAL_ANNOUNCEMENT_HTML
    ) {
      bar.innerHTML = ORIGINAL_ANNOUNCEMENT_HTML;
    }
  }

  function init() {
    captureOriginal();
    restoreBar();
  }

  // Run early
  document.addEventListener("DOMContentLoaded", init);

  // Watch for Shopify / app DOM interference
  const observer = new MutationObserver(() => {
    captureOriginal();
    restoreBar();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();